import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { getCategoriesList } from 'services/types';
import { themes, Dialog, SimpleForm, SimpleFormGroup } from 'libs/ui';
import { Content } from './category-set-form.styled';

export const CategorySetForm = (props) => {
  const { working } = props;
  const { t } = useTranslation();
  const [item, setItem] = useState('');
  /**
   * make action
   * @param {*} event
   */
  const submit = () => {
    const values = { vehicle_category: item ? parseInt(item) : null };
    return props.action(values);
  };

  /**
   * change item
   * @param {*} event
   */
  const handleChange = (event) => {
    setItem(event.target.value);
  };

  const valid = true; //!!item;

  return (
    <Dialog
      // w={480}
      id="dialog-cat-set-form"
      title={t('Изменить категорию ТС у выбранных записей')}
      buttons={[
        { title: t('buttons.Отменить'), onClick: props.close },
        { title: t('buttons.Заменить'), onClick: submit, theme: themes.blue, disabled: !valid || working, working },
      ]}
    >
      <Content>
        <SimpleForm>
          <SimpleFormGroup>
            <label htmlFor="set-form-cat">{t('form.Категория')}</label>
            <select id="set-form-cat" onChange={handleChange} value={item} name="vehicle_category">
              <option value="">{t('form.Не задано')}</option>
              {getCategoriesList()}
            </select>
          </SimpleFormGroup>
        </SimpleForm>
      </Content>
    </Dialog>
  );
};
